import React from 'react';
import { Share2, MessageSquare, ThumbsUp, MoreHorizontal } from 'lucide-react';
export function ArticleContentPT() {
  return <article className="w-full max-w-3xl mx-auto pt-2 pb-12" data-id="element-659">
      {/* Header */}
      <header className="mb-5" data-id="element-660">
        <h1 className="text-2xl md:text-3xl font-bold text-gray-900 leading-tight mb-3 tracking-tight" data-id="element-661">
          Diga Adeus ao ChatGPT HEYLLOYD Em Breve Dominará Seu Laptop
        </h1>

        <div className="flex items-center text-sm text-gray-500 mb-4" data-id="element-662">
          <span className="font-medium text-gray-700" data-id="element-663">Por Redação</span>
          <span className="mx-2 text-gray-300" data-id="element-664">•</span>
          <time data-id="element-665">Agora mesmo</time>
        </div>

        {/* Action Bar */}
        <div className="flex items-center gap-3 mb-6 border-y border-gray-100 py-2.5" data-id="element-666">
          <button className="flex items-center gap-1.5 text-gray-600 hover:text-blue-600 transition-colors text-sm font-medium" data-id="element-667">
            <ThumbsUp className="w-4 h-4" data-id="element-668" />
            <span data-id="element-669">Curtir</span>
          </button>
          <button className="flex items-center gap-1.5 text-gray-600 hover:text-blue-600 transition-colors text-sm font-medium" data-id="element-670">
            <MessageSquare className="w-4 h-4" data-id="element-671" />
            <span data-id="element-672">Comentar</span>
          </button>
          <button className="flex items-center gap-1.5 text-gray-600 hover:text-blue-600 transition-colors text-sm font-medium ml-auto" data-id="element-673">
            <Share2 className="w-4 h-4" data-id="element-674" />
            <span data-id="element-675">Compartilhar</span>
          </button>
          <button className="text-gray-400 hover:text-gray-600" data-id="element-676">
            <MoreHorizontal className="w-4 h-4" data-id="element-677" />
          </button>
        </div>
      </header>

      {/* Hero Image */}
      <figure className="mb-6" data-id="element-678">
        <div className="aspect-[16/10] w-full bg-red-50 overflow-hidden relative shadow-sm" data-id="element-679">
          <img src="https://cdn.magicpatterns.com/uploads/3oFLTXXPbehgPJWRxztxBf/hl_screen_3.png" alt="Laptop mostrando interface de IA HEYLLOYD" className="w-full h-full object-cover" data-id="element-680" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/10 to-transparent pointer-events-none" data-id="element-681"></div>
        </div>
        <figcaption className="mt-2 text-xs text-gray-500 text-center" data-id="element-682">
          Interface de IA HEYLLOYD no laptop
        </figcaption>
      </figure>

      {/* Article Body */}
      <div className="prose prose-base max-w-none text-gray-800" data-id="element-683">
        <p className="mb-4 leading-relaxed text-[15px]" data-id="element-684">
          Uma nova geração de IA está surgindo e não é apenas mais um chatbot.
        </p>

        <p className="mb-4 leading-relaxed text-[15px]" data-id="element-685">
          À medida que a Apple acelera seu avanço na era da Apple Intelligence,
          a IA está indo além de conversas simples e entrando na execução real.
          Um dos recém-chegados mais comentados é{' '}
          <a href="https://direct.heylloyd.io" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline" data-id="element-686">
            HEYLLOYD
          </a>
          , um aplicativo de IA projetado para operar como uma camada
          inteligente em todo o seu laptop.
        </p>

        <p className="mb-4 leading-relaxed text-[15px]" data-id="element-687">
          O ChatGPT mudou a forma como as pessoas interagem com IA através de
          texto. Mas nunca foi construído para entender contexto contínuo,
          gerenciar fluxos de trabalho ou assistir ativamente em aplicativos e
          arquivos.{' '}
          <a href="https://direct.heylloyd.io" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline" data-id="element-688">
            HEYLLOYD
          </a>{' '}
          é.
        </p>

        <p className="mb-4 leading-relaxed text-[15px]" data-id="element-689">
          Em vez de viver em uma aba do navegador,{' '}
          <a href="https://direct.heylloyd.io" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline" data-id="element-690">
            HEYLLOYD
          </a>{' '}
          está se posicionando como uma inteligência sempre ativa que entende no
          que você está trabalhando, lembra intenções e ajuda os usuários a
          planejar, decidir e executar em tempo real.
        </p>

        <p className="mb-4 leading-relaxed text-[15px]" data-id="element-691">
          O que está chamando ainda mais atenção é o posicionamento.{' '}
          <a href="https://direct.heylloyd.io" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline" data-id="element-692">
            HEYLLOYD
          </a>{' '}
          está atualmente com preço de $7 por mês, uma fração dos $24/mês que
          muitos usuários agora pagam pelo ChatGPT Pro, enquanto visa
          substituí-lo inteiramente lidando com trabalho real, não apenas
          respostas.
        </p>

        <div className="my-6 p-4 bg-blue-50 rounded-lg border-l-4 border-blue-500" data-id="element-693">
          <h3 className="text-base font-bold text-blue-900 mb-2" data-id="element-694">
            Principais Diferenças
          </h3>
          <ul className="list-disc list-inside space-y-1.5 text-blue-800 text-[15px]" data-id="element-695">
            <li data-id="element-696">Inteligência sempre ativa em todo o seu laptop</li>
            <li data-id="element-697">Entende contexto contínuo e fluxo de trabalho</li>
            <li data-id="element-698">Assistência proativa sem prompts constantes</li>
          </ul>
        </div>

        <p className="mb-4 leading-relaxed text-[15px]" data-id="element-699">
          Com a Apple Intelligence integrando IA mais profundamente no macOS e
          iOS, aplicativos como{' '}
          <a href="https://direct.heylloyd.io" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline" data-id="element-700">
            HEYLLOYD
          </a>{' '}
          estão perfeitamente sincronizados. Em vez de substituir o ecossistema
          da Apple,{' '}
          <a href="https://direct.heylloyd.io" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline" data-id="element-701">
            HEYLLOYD
          </a>{' '}
          o aprimora atuando como a camada de pensamento que conecta
          ferramentas, apresenta insights e reduz o atrito no trabalho diário.
        </p>

        <p className="mb-4 leading-relaxed text-[15px]" data-id="element-702">
          Prévias iniciais sugerem que{' '}
          <a href="https://direct.heylloyd.io" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline" data-id="element-703">
            HEYLLOYD
          </a>{' '}
          não vai apenas responder perguntas. Vai ajudar a organizar
          informações, automatizar decisões e assistir usuários proativamente
          sem o constante vai-e-vem de prompts que os chatbots tradicionais
          exigem.
        </p>

        <p className="mb-4 leading-relaxed text-[15px]" data-id="element-704">
          O ChatGPT não vai desaparecer da noite para o dia. Mas à medida que a
          IA muda de conversa para execução, ferramentas como{' '}
          <a href="https://direct.heylloyd.io" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline" data-id="element-705">
            HEYLLOYD
          </a>{' '}
          especialmente aquelas desafiando tanto a função quanto o preço dos
          incumbentes podem definir como será realmente a próxima fase da
          computação pessoal.
        </p>
      </div>

      {/* Tags */}
      <div className="mt-8 flex flex-wrap gap-2" data-id="element-706">
        {['HEYLLOYD', 'IA', 'Apple Intelligence', 'Notícias Tech', 'Produtividade'].map(tag => <span key={tag} className="px-2.5 py-1 bg-gray-100 text-gray-600 text-xs rounded-full hover:bg-gray-200 cursor-pointer transition-colors" data-id="element-707">
            #{tag}
          </span>)}
      </div>

      {/* CTA Section */}
      <div className="mt-10 p-6 bg-gradient-to-br from-blue-50 to-indigo-50 rounded-xl border border-blue-100 shadow-sm" data-id="element-708">
        <div className="text-center" data-id="element-709">
          <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-2" data-id="element-710">
            Obtenha HEYLLOYD Antes que os Preços Aumentem
          </h3>
          <p className="text-sm md:text-base text-gray-700 mb-4 max-w-xl mx-auto" data-id="element-711">
            Garanta o preço introdutório de apenas{' '}
            <span className="font-bold text-blue-600" data-id="element-712">$7/mês</span> antes que
            suba. Junte-se aos primeiros adotantes experimentando o futuro da
            produtividade impulsionada por IA.
          </p>
          <a href="https://direct.heylloyd.io" target="_blank" rel="noopener noreferrer" className="inline-block px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-lg transition-colors shadow-md hover:shadow-lg" data-id="element-713">
            Comece Agora
          </a>
          <p className="text-xs text-gray-500 mt-3" data-id="element-714">
            Preço introdutório por tempo limitado
          </p>
        </div>
      </div>

      {/* Facebook-Style Comments Section - Mobile Only */}
      <div className="md:hidden mt-8 border-t border-gray-200 pt-6" data-id="element-715">
        <h3 className="text-lg font-bold text-gray-900 mb-4" data-id="element-716">Comentários</h3>

        <div className="space-y-4" data-id="element-717">
          {/* Comment 1 */}
          <div className="flex gap-2" data-id="element-718">
            <img src="https://randomuser.me/api/portraits/women/44.jpg" alt="Maria Silva" className="w-8 h-8 rounded-full flex-shrink-0" data-id="element-719" />
            <div className="flex-1" data-id="element-720">
              <div className="bg-gray-100 rounded-2xl px-3 py-2" data-id="element-721">
                <p className="font-semibold text-sm" data-id="element-722">Maria Silva</p>
                <p className="text-sm text-gray-800" data-id="element-723">
                  Acabei de me inscrever! Isso é exatamente o que eu estava
                  procurando. ChatGPT estava ficando muito caro 💸
                </p>
              </div>
              <div className="flex items-center gap-3 mt-1 ml-3 text-xs text-gray-500" data-id="element-724">
                <span data-id="element-725">👍 24</span>
                <span data-id="element-726">❤️ 8</span>
                <span data-id="element-727">2h</span>
              </div>
            </div>
          </div>

          {/* Comment 2 with reply */}
          <div className="flex gap-2" data-id="element-728">
            <img src="https://randomuser.me/api/portraits/men/32.jpg" alt="João Santos" className="w-8 h-8 rounded-full flex-shrink-0" data-id="element-729" />
            <div className="flex-1" data-id="element-730">
              <div className="bg-gray-100 rounded-2xl px-3 py-2" data-id="element-731">
                <p className="font-semibold text-sm" data-id="element-732">João Santos</p>
                <p className="text-sm text-gray-800" data-id="element-733">
                  Espera, $7/mês vs $24 pelo ChatGPT Pro? Isso é um valor insano
                  🔥
                </p>
              </div>
              <div className="flex items-center gap-3 mt-1 ml-3 text-xs text-gray-500" data-id="element-734">
                <span data-id="element-735">👍 42</span>
                <span data-id="element-736">😮 15</span>
                <span data-id="element-737">3h</span>
              </div>

              {/* Reply */}
              <div className="flex gap-2 mt-3 ml-6" data-id="element-738">
                <img src="https://randomuser.me/api/portraits/women/68.jpg" alt="Ana Costa" className="w-7 h-7 rounded-full flex-shrink-0" data-id="element-739" />
                <div className="flex-1" data-id="element-740">
                  <div className="bg-gray-100 rounded-2xl px-3 py-2" data-id="element-741">
                    <p className="font-semibold text-xs" data-id="element-742">Ana Costa</p>
                    <p className="text-xs text-gray-800" data-id="element-743">
                      Né?! Já mudei e estou amando
                    </p>
                  </div>
                  <div className="flex items-center gap-3 mt-1 ml-3 text-xs text-gray-500" data-id="element-744">
                    <span data-id="element-745">👍 12</span>
                    <span data-id="element-746">1h</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Comment 3 */}
          <div className="flex gap-2" data-id="element-747">
            <img src="https://randomuser.me/api/portraits/men/22.jpg" alt="Carlos Oliveira" className="w-8 h-8 rounded-full flex-shrink-0" data-id="element-748" />
            <div className="flex-1" data-id="element-749">
              <div className="bg-gray-100 rounded-2xl px-3 py-2" data-id="element-750">
                <p className="font-semibold text-sm" data-id="element-751">Carlos Oliveira</p>
                <p className="text-sm text-gray-800" data-id="element-752">
                  Usando há uma semana. Ele realmente entende no que estou
                  trabalhando sem eu ter que explicar tudo 👏
                </p>
              </div>
              <div className="flex items-center gap-3 mt-1 ml-3 text-xs text-gray-500" data-id="element-753">
                <span data-id="element-754">👍 38</span>
                <span data-id="element-755">❤️ 12</span>
                <span data-id="element-756">4h</span>
              </div>
            </div>
          </div>

          {/* Comment 4 */}
          <div className="flex gap-2" data-id="element-757">
            <img src="https://randomuser.me/api/portraits/women/12.jpg" alt="Juliana Lima" className="w-8 h-8 rounded-full flex-shrink-0" data-id="element-758" />
            <div className="flex-1" data-id="element-759">
              <div className="bg-gray-100 rounded-2xl px-3 py-2" data-id="element-760">
                <p className="font-semibold text-sm" data-id="element-761">Juliana Lima</p>
                <p className="text-sm text-gray-800" data-id="element-762">
                  Isso é revolucionário para produtividade. Chega de ficar
                  trocando de abas!
                </p>
              </div>
              <div className="flex items-center gap-3 mt-1 ml-3 text-xs text-gray-500" data-id="element-763">
                <span data-id="element-764">👍 29</span>
                <span data-id="element-765">5h</span>
              </div>
            </div>
          </div>

          {/* Comment 5 with replies */}
          <div className="flex gap-2" data-id="element-766">
            <img src="https://randomuser.me/api/portraits/men/46.jpg" alt="Pedro Alves" className="w-8 h-8 rounded-full flex-shrink-0" data-id="element-767" />
            <div className="flex-1" data-id="element-768">
              <div className="bg-gray-100 rounded-2xl px-3 py-2" data-id="element-769">
                <p className="font-semibold text-sm" data-id="element-770">Pedro Alves</p>
                <p className="text-sm text-gray-800" data-id="element-771">
                  Funciona no Windows também ou só Mac?
                </p>
              </div>
              <div className="flex items-center gap-3 mt-1 ml-3 text-xs text-gray-500" data-id="element-772">
                <span data-id="element-773">👍 8</span>
                <span data-id="element-774">6h</span>
              </div>

              {/* Reply */}
              <div className="flex gap-2 mt-3 ml-6" data-id="element-775">
                <img src="https://randomuser.me/api/portraits/women/27.jpg" alt="Fernanda Souza" className="w-7 h-7 rounded-full flex-shrink-0" data-id="element-776" />
                <div className="flex-1" data-id="element-777">
                  <div className="bg-gray-100 rounded-2xl px-3 py-2" data-id="element-778">
                    <p className="font-semibold text-xs" data-id="element-779">Fernanda Souza</p>
                    <p className="text-xs text-gray-800" data-id="element-780">
                      Funciona nos dois! Usando no Windows agora mesmo
                    </p>
                  </div>
                  <div className="flex items-center gap-3 mt-1 ml-3 text-xs text-gray-500" data-id="element-781">
                    <span data-id="element-782">👍 18</span>
                    <span data-id="element-783">5h</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Comment 6 */}
          <div className="flex gap-2" data-id="element-784">
            <img src="https://randomuser.me/api/portraits/men/54.jpg" alt="Ricardo Ferreira" className="w-8 h-8 rounded-full flex-shrink-0" data-id="element-785" />
            <div className="flex-1" data-id="element-786">
              <div className="bg-gray-100 rounded-2xl px-3 py-2" data-id="element-787">
                <p className="font-semibold text-sm" data-id="element-788">Ricardo Ferreira</p>
                <p className="text-sm text-gray-800" data-id="element-789">
                  Finalmente cancelei minha assinatura do ChatGPT. HEYLLOYD faz
                  tudo que preciso e mais 🎯
                </p>
              </div>
              <div className="flex items-center gap-3 mt-1 ml-3 text-xs text-gray-500" data-id="element-790">
                <span data-id="element-791">👍 51</span>
                <span data-id="element-792">❤️ 19</span>
                <span data-id="element-793">7h</span>
              </div>
            </div>
          </div>

          {/* Comment 7 */}
          <div className="flex gap-2" data-id="element-794">
            <img src="https://randomuser.me/api/portraits/women/33.jpg" alt="Beatriz Martins" className="w-8 h-8 rounded-full flex-shrink-0" data-id="element-795" />
            <div className="flex-1" data-id="element-796">
              <div className="bg-gray-100 rounded-2xl px-3 py-2" data-id="element-797">
                <p className="font-semibold text-sm" data-id="element-798">Beatriz Martins</p>
                <p className="text-sm text-gray-800" data-id="element-799">
                  A consciência de contexto é incrível. Ele sabe no que estou
                  trabalhando sem eu dizer!
                </p>
              </div>
              <div className="flex items-center gap-3 mt-1 ml-3 text-xs text-gray-500" data-id="element-800">
                <span data-id="element-801">👍 33</span>
                <span data-id="element-802">😮 9</span>
                <span data-id="element-803">8h</span>
              </div>
            </div>
          </div>

          {/* Comment 8 */}
          <div className="flex gap-2" data-id="element-804">
            <img src="https://randomuser.me/api/portraits/men/71.jpg" alt="Lucas Rodrigues" className="w-8 h-8 rounded-full flex-shrink-0" data-id="element-805" />
            <div className="flex-1" data-id="element-806">
              <div className="bg-gray-100 rounded-2xl px-3 py-2" data-id="element-807">
                <p className="font-semibold text-sm" data-id="element-808">Lucas Rodrigues</p>
                <p className="text-sm text-gray-800" data-id="element-809">
                  Melhor $7 que gastei este mês. Seriamente impressionado 💯
                </p>
              </div>
              <div className="flex items-center gap-3 mt-1 ml-3 text-xs text-gray-500" data-id="element-810">
                <span data-id="element-811">👍 44</span>
                <span data-id="element-812">❤️ 16</span>
                <span data-id="element-813">9h</span>
              </div>
            </div>
          </div>

          {/* Comment 9 with reply */}
          <div className="flex gap-2" data-id="element-814">
            <img src="https://randomuser.me/api/portraits/women/50.jpg" alt="Camila Pereira" className="w-8 h-8 rounded-full flex-shrink-0" data-id="element-815" />
            <div className="flex-1" data-id="element-816">
              <div className="bg-gray-100 rounded-2xl px-3 py-2" data-id="element-817">
                <p className="font-semibold text-sm" data-id="element-818">Camila Pereira</p>
                <p className="text-sm text-gray-800" data-id="element-819">
                  Como isso custa apenas $7? O valor é insano comparado a outras
                  ferramentas de IA
                </p>
              </div>
              <div className="flex items-center gap-3 mt-1 ml-3 text-xs text-gray-500" data-id="element-820">
                <span data-id="element-821">👍 37</span>
                <span data-id="element-822">10h</span>
              </div>

              {/* Reply */}
              <div className="flex gap-2 mt-3 ml-6" data-id="element-823">
                <img src="https://randomuser.me/api/portraits/men/18.jpg" alt="Bruno Carvalho" className="w-7 h-7 rounded-full flex-shrink-0" data-id="element-824" />
                <div className="flex-1" data-id="element-825">
                  <div className="bg-gray-100 rounded-2xl px-3 py-2" data-id="element-826">
                    <p className="font-semibold text-xs" data-id="element-827">Bruno Carvalho</p>
                    <p className="text-xs text-gray-800" data-id="element-828">
                      Preço introdutório! Pegue antes que suba
                    </p>
                  </div>
                  <div className="flex items-center gap-3 mt-1 ml-3 text-xs text-gray-500" data-id="element-829">
                    <span data-id="element-830">👍 22</span>
                    <span data-id="element-831">9h</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Comment 10 */}
          <div className="flex gap-2" data-id="element-832">
            <img src="https://randomuser.me/api/portraits/men/63.jpg" alt="Rafael Mendes" className="w-8 h-8 rounded-full flex-shrink-0" data-id="element-833" />
            <div className="flex-1" data-id="element-834">
              <div className="bg-gray-100 rounded-2xl px-3 py-2" data-id="element-835">
                <p className="font-semibold text-sm" data-id="element-836">Rafael Mendes</p>
                <p className="text-sm text-gray-800" data-id="element-837">
                  Usando para programação e é incrível. Entende meu projeto
                  inteiro 🚀
                </p>
              </div>
              <div className="flex items-center gap-3 mt-1 ml-3 text-xs text-gray-500" data-id="element-838">
                <span data-id="element-839">👍 48</span>
                <span data-id="element-840">❤️ 14</span>
                <span data-id="element-841">11h</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </article>;
}